import { IInitialPropsSsr, MainpageMortgageWidgetSsr } from '@cian/finance-mainpage-mortgage-widget-ssr';
import cn from 'classnames';
import React, { useMemo, useRef } from 'react';
import { IMortgageBankShort } from '../../types/mortgage/bank';
import { IMortgagePropertyRates } from '../../types/mortgage/data';
import * as styles from './MortgageLanding.css';
import { useMortgagePvzOffersButtonAnalytics } from './useMortgagePvzOffersButtonAnalytics';

export interface IMortgageLandingProps {
  loanTerm?: number;
  propertyAmount?: number;
  initialPayment?: number;
  pageType?: string;
  banks: IMortgageBankShort[];
  rates: IMortgagePropertyRates;
}

export const MortgageLanding = ({
  loanTerm,
  propertyAmount,
  initialPayment,
  pageType,
  banks,
  rates,
}: IMortgageLandingProps) => {
  const analyticsRootRef = useRef<HTMLDivElement>(null);
  useMortgagePvzOffersButtonAnalytics(analyticsRootRef);

  const calculatorState = useMemo<IInitialPropsSsr['calculatorWidgetState']>(
    () => ({
      loanTerm,
      propertyAmount,
      initialPayment,
    }),
    [initialPayment, loanTerm, propertyAmount],
  );

  return (
    <div className={styles.wrapper} ref={analyticsRootRef}>
      <div className={cn('cg-container-fluid-xs', styles.root)}>
        <MainpageMortgageWidgetSsr
          pageType={pageType}
          calculatorWidgetState={calculatorState}
          banks={banks}
          rates={rates}
        />
      </div>
    </div>
  );
};
